import { render, staticRenderFns } from "./BaseFilterTags.vue?vue&type=template&id=a522771c&scoped=true&"
import script from "./BaseFilterTags.vue?vue&type=script&lang=js&"
export * from "./BaseFilterTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a522771c",
  null
  
)

export default component.exports